import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

export default function Daftar({ data, closing }) {
  return (
    <section className="w-full -md:pt-20 bg-no-repeat bg-daftar">
      <div className="flex md:px-20 container flex-col justify-center text-center items-center">
        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
          <h1 className="text-6xl font-black italic text-purple animate-pulse">
            {data.title}
          </h1>
          <h2 className="text-2xl font-black italic text-purple animate-pulse">
            {data.subtitle}
          </h2>
        </ScrollAnimation>
        <div className="relative -md:w-10/12">
          <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
            <a href={data.button_link} target="_blank" rel="noreferrer">
              <img
                src={data.button}
                className="mt-4 transform transition-all hover:scale-105"
                alt="Button"
              />
            </a>
            <img
              className="absolute bottom-0 -md:-bottom-10 -right-16 animate-bounce -md:w-1/3"
              src={data.cursor}
              alt="Cursor"
            />
          </ScrollAnimation>
        </div>
        <ScrollAnimation animateOnce={true} animateIn="fadeIn">
          <img className="mt-20" src={data.barcode} alt="Barcode" />
        </ScrollAnimation>
        <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
          <h2 className="text-4xl font-black italic">{data.barcode_text}</h2>
        </ScrollAnimation>
        <div className="mt-16 flex justify-center items-center flex-col md:w-1/2 -md:container md:space-y-8 -md:space-y-4">
          {data.sosmed.map((sosmed, i) => (
            <ScrollAnimation key={i} animateOnce={true} animateIn="fadeInUp">
              <a href={sosmed.cta_link} target="_blank" rel="noreferrer">
                <div className="relative bg-gradient-to-r from-yellow-secondary to-yellow rounded-full px-6 py-3 md:text-2xl shadow-lg">
                  <p
                    className="-md:text-xs"
                    dangerouslySetInnerHTML={{
                      __html: sosmed.description,
                    }}
                  />
                  <img
                    className="absolute md:-left-10 -md:-left-6 top-0 my-auto h-14 -md:h-10 w-auto"
                    src={sosmed.image}
                    alt="Sosmed"
                  />
                </div>
              </a>
            </ScrollAnimation>
          ))}
        </div>
      </div>
      <img
        src={closing.image}
        className="w-full md:mt-52 -md:mt-28"
        alt="footer"
      />
      <style
        dangerouslySetInnerHTML={{
          __html: `
			.bg-daftar {
				background-image: url(/images/line-left.png), url(/images/line-right.png);
				background-position: left top, right top;
			}
			@media only screen and (max-width: 767px) {
				.bg-daftar {
					background-image: none;
				}
			  }
		  `,
        }}
      />
    </section>
  );
}
